module.exports = "\r\n    <app-cameras-item></app-cameras-item>\r\n"